var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M24,7c-0.55273,0-1-0.44727-1-1V2c0-0.55273,0.44727-1,1-1s1,0.44727,1,1v4C25,6.55273,24.55273,7,24,7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M32,11h-3V6c0-0.55273-0.44727-1-1-1h-8c-0.55273,0-1,0.44727-1,1v5h-3c-0.55273,0-1,0.44727-1,1v34 c0,0.55273,0.44727,1,1,1h16c0.55273,0,1-0.44727,1-1V12C33,11.44727,32.55273,11,32,11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M20,27H4c-0.55273,0-1,0.44727-1,1v18c0,0.55273,0.44727,1,1,1h16c0.55273,0,1-0.44727,1-1V28 C21,27.44727,20.55273,27,20,27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#444444",
    d: "M44,21H28c-0.55273,0-1,0.44727-1,1v24c0,0.55273,0.44727,1,1,1h16c0.55273,0,1-0.44727,1-1V22 C45,21.44727,44.55273,21,44,21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M37,40h-2c-0.55228,0-1,0.44772-1,1v6h4v-6C38,40.44772,37.55228,40,37,40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M13,41h-2c-0.55229,0-1,0.44772-1,1v5h4v-5C14,41.44772,13.55229,41,13,41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BADEFC",
    d: "M34,29h-2c-0.55228,0-1-0.44772-1-1v-2c0-0.55228,0.44772-1,1-1h2c0.55228,0,1,0.44772,1,1v2 C35,28.55228,34.55228,29,34,29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BADEFC",
    d: "M40,29h-2c-0.55228,0-1-0.44772-1-1v-2c0-0.55228,0.44772-1,1-1h2c0.55228,0,1,0.44772,1,1v2 C41,28.55228,40.55228,29,40,29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BADEFC",
    d: "M34,35h-2c-0.55228,0-1-0.44772-1-1v-2c0-0.55228,0.44772-1,1-1h2c0.55228,0,1,0.44772,1,1v2 C35,34.55228,34.55228,35,34,35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BADEFC",
    d: "M40,35h-2c-0.55228,0-1-0.44772-1-1v-2c0-0.55228,0.44772-1,1-1h2c0.55228,0,1,0.44772,1,1v2 C41,34.55228,40.55228,35,40,35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10,36H8c-0.55228,0-1-0.44772-1-1v-2c0-0.55228,0.44772-1,1-1h2c0.55229,0,1,0.44772,1,1v2 C11,35.55228,10.55229,36,10,36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M16,36h-2c-0.55229,0-1-0.44772-1-1v-2c0-0.55228,0.44771-1,1-1h2c0.55228,0,1,0.44772,1,1v2 C17,35.55228,16.55228,36,16,36z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.21c1a484e9b5d52eaaae4835f3629e60.svg";
export { ForwardRef as ReactComponent };